import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  current_exam_id: null,
  user_exam_id: null,
  is_performing: false,
  proctoring_session_active: false
};

export const examSlice = createSlice({
  name: 'currentExam',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setCurrentExam: (state, action) => {
        state.current_exam_id = action.payload.exam_id
        state.user_exam_id = action.payload.user_exam_id
        state.is_performing = true
    },
    setProctoringSessionActive: (state, action) => {
        state.proctoring_session_active = action.payload.session_active
    },
    resetProctoringSession: (state) => {
        state.proctoring_session_active = false
    },
    resetCurrentExam: (state) => {
        state.current_exam_id = null
        state.user_exam_id = null
        state.is_performing = true
    },
  },
});

export const { setCurrentExam, resetCurrentExam, setProctoringSessionActive, resetProctoringSession } = examSlice.actions;

export const selectCurrentExamId = (state) => state.currentExam.current_exam_id;
export const selectCurrentUserExamId = (state) => state.currentExam.user_exam_id;
export const selectCurrentProctoringSessionActive = (state) => state.currentExam.proctoring_session_active;

export default examSlice.reducer;
